import * as fromDatatype from '../datatype-library/index';

export interface app_ui_mst_launcher_widget_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  widget_type: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  panel_guid: fromDatatype.GuidDataFieldInterface;
  level: fromDatatype.IntegerDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_ui_mst_launcher_widget_RowClass
  implements app_ui_mst_launcher_widget_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  widget_type: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  panel_guid: fromDatatype.GuidDataFieldInterface;
  level: fromDatatype.IntegerDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
